module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/refresh-f606eef12d3701eb7b3ce129118bbe0e.png";